import { render, staticRenderFns } from "./AccessProfiles.vue?vue&type=template&id=2b0cbabc&scoped=true&"
import script from "./AccessProfiles.vue?vue&type=script&lang=js&"
export * from "./AccessProfiles.vue?vue&type=script&lang=js&"
import style0 from "./AccessProfiles.vue?vue&type=style&index=0&id=2b0cbabc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cbabc",
  null
  
)

export default component.exports